/**
 * Created by Jerker Nord on 2023-09-26.
 */
import {GuiButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";
import {PointerState} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/PointerState";

export class LonerTargetButton extends GuiButton {

    private _button: PIXI.Sprite;
    private _offTexture: PIXI.Texture;
    private _onTexture: PIXI.Texture;
    private _currentState: number = 0;
    private _isSelected:boolean = false;

    constructor(name: string, offTexture: PIXI.Texture, onTexture: PIXI.Texture, clickCallback?: Function) {
        super(name, clickCallback);

        this._offTexture = offTexture;
        this._onTexture = onTexture;
        this._button = new PIXI.Sprite(this._offTexture);

        this._button.anchor.set(0.5);
        this.addChild(this._button);
        this.hitArea = new PIXI.Rectangle(0 - (this.width / 2), 0 - (this.height / 2), this.width, this.height);
    }

    public enable(enable: boolean) {
        super.enable(enable);
    }

    /**
     [PointerState.IDLE] = 0
     [PointerState.DOWN] = 1
     [PointerState.OVER] = 2
     [PointerState.DISABLED] = 3
     */
    protected onPointerStateUpdate(state: PointerState): void{
        if (this._isSelected == true){
            return;
        }
        this._currentState = state;
        if (state == 0) {
            this._button.texture = this._offTexture;
        } else if (state == 2 || state == 1){
            this._button.texture = this._onTexture;
        }
    }

    set isSelected(value: boolean) {
        this._isSelected = value;
        this._button.texture = this._onTexture;
    }

    public reset():void{
        this.isSelected = false;
        this._button.texture = this._offTexture;
    }
}